import { Outlet } from 'react-router-dom'
import { AppShell } from '@/shared/ui/layout'
import { NavBadgeProvider } from '@/shared/ui/providers'
import { FeedbackDialogProvider } from '@/modules/feedback/ui/providers'
import { LegalProvider } from '@/modules/legal/ui/providers'
import { ParcelInfoCacheProvider } from '@/modules/properties/ui/providers'
import { makeSubmitFeedback, makeUploadFeedbackAttachment } from '@/main/factories/modules/feedback'
import { makeRecordLegalAcceptance } from '@/main/factories/modules/legal'
import { makeLoadConnectUnreadTotal, makeLoadHuntTypesWithActivity } from '@/main/factories/shared'
import { makeListChannels } from '@/main/factories/modules/connect'

const recordLegalAcceptance = makeRecordLegalAcceptance()
const submitFeedback = makeSubmitFeedback()
const uploadFeedbackAttachment = makeUploadFeedbackAttachment()
const loadConnectUnreadTotal = makeLoadConnectUnreadTotal()
const listChannels = makeListChannels()
const loadHuntTypesWithActivity = makeLoadHuntTypesWithActivity()

export function DashboardShellRoute() {
  return (
    <FeedbackDialogProvider
      onSubmitFeedback={submitFeedback}
      onUploadFeedbackAttachment={uploadFeedbackAttachment}
    >
      <NavBadgeProvider onLoadConnectUnreadTotal={loadConnectUnreadTotal}>
        <AppShell
          onListChannels={listChannels}
          onLoadHuntTypesWithActivity={loadHuntTypesWithActivity}
        >
          <LegalProvider onRecordLegalAcceptance={recordLegalAcceptance}>
            <ParcelInfoCacheProvider>
              <Outlet />
            </ParcelInfoCacheProvider>
          </LegalProvider>
        </AppShell>
      </NavBadgeProvider>
    </FeedbackDialogProvider>
  )
}
